<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="createForm.id? '修改优惠券' :'新增优惠券'"
    width="30%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="优惠券名称"
          prop="couponName"
        >
          <el-input v-model="createForm.couponName" />
        </el-form-item>
        <el-form-item
          label="优惠券类型"
          prop="couponType"
        >
          <el-radio-group v-model="createForm.couponType">
            <el-radio
              v-for="radio in couponTypeList"
              :key="radio.value"
              :label="radio.value"
            >
              {{ radio.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="createForm.couponType === 30"
          label="指定课程"
          prop="courseId"
        >
          <el-select
            v-model="createForm.courseId"
            filterable
            clearable
            placeholder="请选择课程"
          >
            <el-option
              v-for="course in couponCourseList"
              :key="course.id"
              :label="course.courseName"
              :value="course.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="过期天数"
          prop="expireDayCount"
        >
          <el-input v-model="createForm.expireDayCount" />
        </el-form-item>
        <el-form-item
          v-if="createForm.couponType !== 40"
          label="优惠券金额"
          prop="discountFee"
        >
          <el-input v-model="createForm.discountFee" />
        </el-form-item>
        <el-form-item
          label="备注"
          prop="remark"
          textarea
        >
          <el-input v-model="createForm.remark" />
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';
import { couponTypeList } from '@/config';

export default {
  name: 'ProductDialog',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      couponTypeList,
      cancelText: '取消',
      couponCourseList: [],
      createForm: {
        id: null,
        courseId: null,
        couponType: null,
        couponName: null,
        expireDayCount: null,
        discountFee: null,
        remark: null,
      },
      creatRules: {
        couponName: [
          { required: true, message: '请输入优惠券名称', trigger: 'blur' },
        ],
        courseId: [
          { required: true, message: '请选择对应课程', trigger: 'blur' },
        ],
        couponType: [
          { required: true, message: '请选择优惠券类型', trigger: 'blur' },
        ],
        expireDayCount: [
          { required: true, message: '请输入过期天数', trigger: 'blur' },
        ],
        discountFee: [
          { required: true, message: '请输入优惠券金额', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    item: {
      handler(val) {
        this.$nextTick(() => {
          if (val) {
            const {
              courseId,
              couponType,
              couponName,
              expireDayCount,
              discountFee,
              remark,
              id,
            } = val;
            this.createForm = {
              courseId,
              couponType,
              couponName,
              expireDayCount,
              discountFee: discountFee / 100,
              remark,
              id,
            };
          } else {
            this.createForm.id = null;
          }
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.getCourseList();
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('update:item', null);
      this.$refs.createForm.clearValidate();
      this.$refs.createForm.resetFields();
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          this.createForm.discountFee *= 100;
          if (!this.createForm.courseId) {
            this.createForm.courseId = -1;
          }
          const data = await axClient.coupon.couponUpsert(this.createForm);
          if (!data) return;
          if (this.createForm.id) {
            this.$message.success('修改优惠券成功');
          } else {
            this.$message.success('新增优惠券成功');
          }
          this.$emit('confirm');
          this.close();
        }
      });
    },
    async getCourseList() {
      this.couponCourseList = await axClient.cert.listCourseNameByCert();
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  .el-radio-group{
    .el-radio{
      margin-bottom: 20px;
    }
  }
}

</style>
